export default "__VITE_ASSET__2be6f2e8__"